import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";

export default function OrderSuccess({ orderSuccess, setOrderSuccess }) {
  const [orderData, setOrderData] = useState();
  const isTimerExpiredRef = useRef(false);
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    // console.log("ordersuccess", orderSuccess);
    const id = orderSuccess.data;
    if (id) {
      // console.log("orderId ", id);
      axios
        .get(`${process.env.REACT_APP_BACKEND_LINK}/getplacedorder?id=${id}`)
        .then((res) => {
          // console.log("orderdata", res);
          setOrderData(res.data);
        })
        .catch((err) => console.log(err));
    }

    // Setting timer to true after 1 sec so that the setOrderSuccess does not run on mount
    const timerExpired = setTimeout(() => {
      // console.log("Set to true");
      isTimerExpiredRef.current = true;
    }, 1000);

    return () => {
      clearTimeout(timerExpired); // Clear the timer on unmount
      if (isTimerExpiredRef.current) {
        // Sets the orderSuccess to false on unmount
        setOrderSuccess({
          flag: false,
          data: "",
        });
      }
    };
  }, []);

  useEffect(() => {
    let fetchTotalPrice = 0;
    orderData?.products.map(
      (product) =>
        (fetchTotalPrice =
          fetchTotalPrice + product.id.price * product.quantity)
    );
    setTotalPrice(fetchTotalPrice);
  }, [orderData]);

  const handleClose = () => {
    setOrderSuccess({
      flag: false,
      data: "",
    });
  };

  return (
    <div className="md:mx-64">
      <div onClick={handleClose} className="mt-16 mb-2 text-xl cursor-pointer">
        <FontAwesomeIcon icon={faArrowLeft} />
      </div>
      <h1 className="text-2xl md:text-4xl font-semibold text-ambhosOrange mt-5">
        Order Placed!
      </h1>
      <h2 className="text-lg md:text-xl font-semibold pb-1">
        Thank you for placing an order with us.
      </h2>
      <div className="flex flex-col md:flex-row w-full">
        <div className="w-auto p-4 border-t-2">
          <div className="border-b pb-2 text-[15px]">
            <p className="">
              <span className="font-semibold">Order Id: </span>
              {orderData?.orderId}
            </p>
            {orderData?.shiprocketDetails.awb.awb_code && (
              <p>
                <span className="font-semibold">AWB Number:</span>{" "}
                {orderData?.shiprocketDetails.awb.awb_code}
              </p>
            )}
            <p>
              <span className="font-semibold">Payment Ref No: </span>
              {orderData?.paymentDetails.razorpay_payment_id}
            </p>
          </div>
          <ul className="py-4 md:px-4 w-full space-y-3">
            {orderData?.products?.map((item) => (
              <li
                key={item.id._id}
                className="flex items-center justify-between py-2"
              >
                <div className="flex">
                  <img
                    src={item?.id?.images ? item?.id?.images[0] : ""}
                    alt={item.id.productName}
                    className="h-8 w-8 object-contain"
                  />
                  <div className="w-96 flex flex-col ml-4">
                    <h3 className="font-medium text-sm inline-block">
                      {item.id.brandName + " " + item.id.productName}
                      {item.id.color && " (" + item.id.color + ") "}
                      {item.selectedSize && "(Size: " + item.selectedSize + ")"}
                    </h3>
                    <p className="text-gray-500 text-xs inline-block">
                      {item?.quantity} x ₹{item.id?.price.toFixed(2)}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Side Container */}
        <div className="px-5 pt-5 border-2">
          <div className="border-b pb-2 leading-5 text-sm">
            <p className="font-semibold">Shipping Address: </p>
            <p className="">
              {orderData?.user.firstName + " " + orderData?.user.lastName}
            </p>
            <p>{orderData?.user?.shippingAddress?.address}</p>
            <p>
              {orderData?.user?.shippingAddress?.city +
                ", " +
                orderData?.user?.shippingAddress?.state}
            </p>
            <p>
              {orderData?.user?.shippingAddress?.country +
                " - " +
                orderData?.user?.shippingAddress?.pincode}
            </p>
            <p>{orderData?.user.phoneNumber}</p>
            {/* <p className="font-semibold mt-5">Order Details:</p> */}
          </div>

          <div>
            <h2 className="mt-5 text-sm font-semibold">PRICE SUMMARY</h2>
            <ul className="text-sm mt-3 space-y-1">
              <li className="flex justify-between">
                <p>Total Price</p>
                <p>₹ {totalPrice.toFixed(2)}</p>
              </li>
              <li className="flex justify-between">
                <p>Coupon Discount</p>
                <p>
                  - ₹{" "}
                  {orderData?.couponDiscount
                    ? orderData?.couponDiscount?.toFixed(2)
                    : "0.00"}
                </p>
              </li>
              <li className="flex justify-between">
                <p>Shipping Charges</p>
                <p>
                  ₹{" "}
                  {orderData?.shippingCharges
                    ? orderData?.shippingCharges?.toFixed(2)
                    : "0.00"}
                </p>
              </li>
            </ul>
            <hr className="my-2" />
            <div className="flex space-x-5 justify-between font-semibold mb-5">
              <p>Amount Paid</p>
              <p>₹ {orderData?.totalAmount.toFixed(2)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
